import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AUTHENTICATION_SCOPES } from '@playbookux/playbook-web-core';

import {
  Modal,
  Container,
  Link,
  Span,
} from './styles';

const CannotTakeTestModal = ({ open, history, scope }) => {
  const handleRedirect = () => {
    history.push('/');
  };
  return (
    <Modal
      open={open}
    >
      <Container>
        <Span>
          Thanks for your interest in this study!
        </Span>
        <Span>
          We’ve filled up all spots but will let you know if anything opens up.
        </Span>
        {scope === AUTHENTICATION_SCOPES.TESTER && <Link onClick={handleRedirect}>Go back to the Browse Tests tab</Link>}
      </Container>
    </Modal>
  );
};

CannotTakeTestModal.propTypes = {
  scope: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = ({ authentication }) => ({
  scope: authentication.scope,
});

export default connect(mapStateToProps, null)(CannotTakeTestModal);
